import React, { useState } from 'react';
import { FaLightbulb, FaLink, FaExclamationCircle, FaBolt, FaEdit } from "react-icons/fa";
import styles from '../../pages/Monitor/Monitor.module.css';

const DigitalOutputCard = ({ type, index, label, icon, data, onUpdate, customNames = {}, onSaveCustomName }) => {
    const [isEditingName, setIsEditingName] = useState(false);
    const [editedName, setEditedName] = useState('');

    if (!data) return null;

    const { status, settings, triggered, causedBy, error } = data;
    const isOn = status === "1";

    // دریافت نام سفارشی برای این خروجی خاص
    const customName = customNames[index];

    const logicModes = ["OR (یا)", "AND (و)", "NOR", "NAND", "XOR", "XNOR"];

    const handleSaveName = () => {
        if (onSaveCustomName) {
            onSaveCustomName(index, editedName.trim());
        }
        setIsEditingName(false);
    };

    const startEditingName = (e) => {
        e.stopPropagation();
        setEditedName(customName || '');
        setIsEditingName(true);
    };

    return (
        <div className={styles.sensorCard}>
            {/* --- هدر (با قابلیت ویرایش نام) --- */}
            <div className={styles.cardHeader}>
                <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                    {icon}
                    <span style={{fontWeight:'bold'}}>
                        {customName ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                <span style={{ fontSize: '14px', color: '#f1c40f' }}>{customName}</span>
                                <span style={{ fontSize: '10px', color: '#7f8c8d' }}>{label}</span>
                            </div>
                        ) : (
                            label
                        )}
                    </span>
                </div>
                
                {/* دکمه ویرایش نام */}
                <div 
                    onClick={startEditingName}
                    style={{ cursor: 'pointer', padding: '5px', color: '#3498db' }}
                    title="ویرایش نام خروجی"
                >
                    <FaEdit />
                </div>
            </div>

            {/* مدال ویرایش نام */}
            {isEditingName && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#2c3e50',
                    padding: '15px',
                    borderRadius: '8px',
                    zIndex: 100,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    minWidth: '200px'
                }}>
                    <div style={{ marginBottom: '10px', fontSize: '12px', color: '#ccc' }}>
                        ویرایش نام خروجی {index}
                    </div>
                    <input
                        type="text"
                        value={editedName}
                        onChange={(e) => setEditedName(e.target.value)}
                        placeholder="مثلاً: پمپ آب"
                        style={{
                            width: '100%',
                            padding: '8px 5px',
                            borderRadius: '4px',
                            border: '1px solid #34495e',
                            backgroundColor: '#1a252f',
                            color: '#f1c40f',
                            marginBottom: '10px'
                        }}
                        autoFocus
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') handleSaveName();
                            if (e.key === 'Escape') setIsEditingName(false);
                        }}
                    />
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                        <button onClick={() => setIsEditingName(false)} style={{ padding: '5px 10px', backgroundColor: '#7f8c8d', border: 'none', borderRadius: '4px', color: '#fff', cursor: 'pointer' }}>لغو</button>
                        <button onClick={handleSaveName} style={{ padding: '5px 10px', backgroundColor: '#2ecc71', border: 'none', borderRadius: '4px', color: '#fff', cursor: 'pointer' }}>ذخیره</button>
                    </div>
                </div>
            )}

            {/* --- وضعیت فعلی خروجی --- */}
            <div className={styles.centerStatus}>
                <FaBolt className={`${styles.powerIcon} ${isOn ? styles.powerOn : styles.powerOff}`} />
                <div className={styles.statusText}>
                    {isOn ? 'خروجی فعال' : 'خروجی غیرفعال'}
                </div>
                {causedBy && (
                    <div style={{fontSize:'10px', color:'#52ae47', marginTop:'5px', display:'flex', alignItems:'center', gap:'4px'}}>
                        <FaLink /> توسط: {causedBy}
                    </div>
                )}
            </div>

            {/* --- گروه تنظیمات --- */}
            <div className={styles.settingsGroup} style={{ position: 'relative', overflow: 'hidden' }}>
                {triggered && <div className={styles.triggerGlow}></div>}

                <div className={styles.triggerIconContainer}>
                    <FaLightbulb
                        className={`${styles.trigIcon} ${triggered ? styles.trigOn : styles.trigOff}`}
                        style={{ fontSize: '18px', transform: 'rotate(180deg)' }}
                    />
                    {triggered && <div className={styles.blinkingTooltip}>Trig فعال</div>}
                </div>

                <div className={styles.settingRow}>
                    <span>فعالسازی (Enable):</span>
                    <label className={styles.toggleSwitch}>
                        <input type="checkbox" checked={settings.enable === "1"} onChange={(e) => onUpdate('enable', e.target.checked ? "1" : "0")} />
                        <span className={styles.slider}></span>
                    </label>
                </div>
                {error && <div style={{color:'#ff4d4d', fontSize:'9px', marginBottom:'10px'}}><FaExclamationCircle /> خطا: وابسته به {error}</div>}

                <div className={styles.settingRow}>
                    <span>منطق (Logic):</span>
                    <select className={styles.inputNum} style={{width:'90px'}} value={settings.logicMode} onChange={(e) => onUpdate('logicMode', e.target.value)}>
                        {logicModes.map((text, i) => <option key={i} value={i}>{text}</option>)}
                    </select>
                </div>

                <div className={styles.settingRow}>
                    <span>تایمر روزانه:</span>
                    <div style={{display:'flex', gap:'4px'}}>
                        <input className={styles.inputNum} style={{width:'45px'}} defaultValue={settings.dailyOn} onBlur={(e) => onUpdate('dailyOn', e.target.value)} />
                        <input className={styles.inputNum} style={{width:'45px'}} defaultValue={settings.dailyOff} onBlur={(e) => onUpdate('dailyOff', e.target.value)} />
                    </div>
                </div>

                <div className={styles.settingRow}>
                    <span>تاخیر (On/Off):</span>
                    <div style={{display:'flex', gap:'4px'}}>
                        <input className={styles.inputNum} style={{width:'45px'}} defaultValue={settings.delayOn} onBlur={(e) => onUpdate('delayOn', e.target.value)} />
                        <input className={styles.inputNum} style={{width:'45px'}} defaultValue={settings.delayOff} onBlur={(e) => onUpdate('delayOff', e.target.value)} />
                    </div>
                </div>

                <div className={styles.settingRow}>
                    <span>متناوب (On/Off):</span>
                    <div style={{display:'flex', gap:'4px'}}>
                        <input className={styles.inputNum} style={{width:'45px'}} defaultValue={settings.periodicOn} onBlur={(e) => onUpdate('periodicOn', e.target.value)} />
                        <input className={styles.inputNum} style={{width:'45px'}} defaultValue={settings.periodicOff} onBlur={(e) => onUpdate('periodicOff', e.target.value)} />
                    </div>
                </div>

                <div className={styles.settingRow}>
                    <span>حالت معکوس / پیامک:</span>
                    <div style={{display:'flex', gap:'10px'}}>
                        <label className={styles.toggleSwitch} title="Reverse"><input type="checkbox" checked={settings.reverse === "1"} onChange={(e) => onUpdate('reverse', e.target.checked ? "1" : "0")} /><span className={styles.slider}></span></label>
                        <label className={styles.toggleSwitch} title="SMS"><input type="checkbox" checked={settings.alertSms === "1"} onChange={(e) => onUpdate('alertSms', e.target.checked ? "1" : "0")} /><span className={styles.slider}></span></label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DigitalOutputCard;